import React from "react";
import PropTypes from "prop-types";

import { purposeShape, PurposeFilter } from "./purpose_filter";
import { TypeFilter } from "./type_filter";
import { regulationShape, Table } from "./table";


class Container extends React.Component {
  constructor(props) {
    super(props);

    const initialState = {
      selectedPurposeFilterOptions: [],
      typeFilterChecked: false,
      visibleRegulationIds: props.table.map(e => e.id)
    };

    this.state = Object.assign({}, initialState);
  }

  render () {
    const regulations = this.props.table;

    const onJumpTo = regulation => {
      this.setState({
        jumpToRegulationId: regulation.id,
        selectedPurposeFilterOptions: [],
        typeFilterChecked: false,
        visibleRegulationIds: regulations.map(e => e.id)
      });
    };

    const numericalTypeFilter = (checked, visibleRegulations) => {
      if (checked) {
        return visibleRegulations.filter(e => e.hasNumericalStandards);
      } else {
        return visibleRegulations;
      }
    };

    const selectFilter = (selectedIds, visibleRegulations, regKey) => {
      const reducer = reg => (found, id) => (found || reg[regKey].includes(id));
      const filterRegs = reg => selectedIds.reduce(reducer(reg), selectedIds.length === 0);

      return visibleRegulations.filter(filterRegs);
    };

    const changeSelectedOptions = (stateKey, regKey) => (newSelection, remove) => () => {
      let newState;
      if (remove) {
        newState = this.state[stateKey].filter(e => e.id !== newSelection.id);
      } else {
        newState = this.state[stateKey].concat(newSelection);
      }
      const newIds = newState.map(e => e.id);

      const typeFiltered = numericalTypeFilter(this.state.typeFilterChecked, selectFilter(newIds, regulations, regKey));
      const visibleRegulationIds = typeFiltered.map(e => e.id);

      this.setState({
        [stateKey]: newState,
        visibleRegulationIds: visibleRegulationIds,
        jumpToRegulationId: null
      });
    };

    const purposeFilterProps = {
      options: this.props.purposeFilterOptions,
      selectedOptions: this.state.selectedPurposeFilterOptions,
      onChange: changeSelectedOptions("selectedPurposeFilterOptions", "purposeIds")
    };

    const typeFilterProps = {
      checked: this.state.typeFilterChecked,
      onClick: () => {
        let newVisibleRegulations = numericalTypeFilter(!this.state.typeFilterChecked, regulations);

        const purposeFiltered = selectFilter(this.state.selectedPurposeFilterOptions.map(e => e.id), newVisibleRegulations, "purposeIds");
        const visibleRegulationIds = purposeFiltered.map(e => e.id);

        this.setState({
          typeFilterChecked: !this.state.typeFilterChecked,
          visibleRegulationIds: visibleRegulationIds
        });
      }
    };

    const tableProps = {
      visibleRegulations: regulations.filter(e => this.state.visibleRegulationIds.includes(e.id)),
      purposes: this.props.purposeFilterOptions,
      targets: this.props.targetOptions,
      onJumpTo: onJumpTo,
      jumpToRegulationId: this.state.jumpToRegulationId
    };

    let typeFilter = <div>Please note that this country is not included in our Regulations database, as such water quality standards are not linked to the database.</div>;
    if (regulations.find(e => e.hasNumericalStandards)) {
      typeFilter = <TypeFilter {...typeFilterProps} />;
    }

    return (
      <div className="country-regulations-table-react-app-root">
        <div className="row">
          <div className="col-md-9">
            <PurposeFilter {...purposeFilterProps} />
          </div>
          <div className="col-md-3">
            {typeFilter}
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <Table {...tableProps} />
          </div>
        </div>
      </div>
    );
  }
}

Container.propTypes = {
  purposeFilterOptions: PropTypes.arrayOf(purposeShape).isRequired,
  table: PropTypes.arrayOf(regulationShape).isRequired,
  targetOptions: PropTypes.arrayOf(purposeShape).isRequired
};

export default Container;
